// extracted by mini-css-extract-plugin
module.exports = {"container":"_3l5LCIm","message":"_2Av3nDX","buttons":"_3VyrObi"};